import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'

import App from './App'
import { FavouriteProvider } from 'context/favourite'

import './styles/tailwind_output.css'
import './index.css'
import './component/layout'

import * as serviceWorker from './serviceWorker'
import history from './utils/history.js'

// Defer analytics initialization to after page load for better performance
const initializeAnalytics = () => {
  // Dynamically import analytics libraries to reduce initial bundle
  Promise.all([
    import('react-ga'),
    import('api/AmpEmailAPI')
  ]).then(([ReactGAModule, AmpEmailAPIModule]) => {
    const ReactGA = ReactGAModule.default;
    const AmpEmailAPI = AmpEmailAPIModule.default;

    const trackingId = 'UA-231034-1'
    ReactGA.initialize(trackingId, {
      gaOptions: { allowLinker: true },
    })

    ReactGA.ga('require', 'linker')
    ReactGA.ga('linker:autoLink', [
      'secure.thinkreservations.com',
      'thinkreservations.com',
    ])

    // Track initial page view
    ReactGA.ga('send', 'pageview', window.location.pathname)
    AmpEmailAPI.trackPage(window.location.pathname.replace('/', ''))

    // Set up history listener for subsequent page views
    history.listen((location) => {
      AmpEmailAPI.trackPage(location.pathname.replace('/', ''))
      ReactGA.set({ page: location.pathname })
      ReactGA.pageview(location.pathname)
    })
  }).catch(err => {
    console.error('Failed to load analytics:', err);
  });
};

// Initialize analytics after the page has loaded
if (document.readyState === 'complete') {
  initializeAnalytics();
} else {
  window.addEventListener('load', initializeAnalytics);
}

const rootElement = document.getElementById('root');

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <FavouriteProvider>
        <App />
      </FavouriteProvider>
    </Router>
  </React.StrictMode>,
  rootElement
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
